import { createSlice } from "@reduxjs/toolkit";
import { fetchMe, updateProfile } from "./thunks";

interface ProfileState {
  loading: boolean;
  error: string | null;
  user?: any | null;
  fetched?: boolean;
}

const initialState: ProfileState = {
  loading: false,
  error: null,
  user: null,
  fetched: false,
};

const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearProfile: (state) => {
      state.user = null;
      state.fetched = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMe.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMe.fulfilled, (state, action: any) => {
        state.loading = false;
        state.fetched = true;
        // Normalização: payload pode ter { user } | { data } | raw user
        const payload = action.payload;
        state.user = payload?.user ?? payload?.data ?? payload ?? null;
      })
      .addCase(fetchMe.rejected, (state, action) => {
        state.loading = false;
        state.error =
          (action.payload as any)?.error || "Erro ao carregar perfil";
      })
      .addCase(updateProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateProfile.fulfilled, (state, action: any) => {
        state.loading = false;
        // Quando o perfil é atualizado, também atualizamos o user local
        const payload = action.payload;
        const newUser = payload?.user ?? payload?.data ?? payload ?? null;
        if (newUser) state.user = newUser;
      })
      .addCase(updateProfile.rejected, (state, action) => {
        state.loading = false;
        state.error =
          (action.payload as any)?.error || "Erro ao atualizar perfil";
      });
  },
});

export const { clearError, clearProfile } = profileSlice.actions;
export default profileSlice.reducer;
